import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import BusinessIcon from '@material-ui/icons/Business';
import {
  getParentSchoolSession,
  isViewingChildSchool,
  restoreParentSchoolSession,
} from '../../utils/schoolImpersonation';
import SchooleRegistrationService from '../../pages/dashboard/Locality/Service/schooleRegistration';

const useStyles = makeStyles((theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.25, 2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: '#fff8e8',
    border: '1px solid #ffe0a3',
  },
  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#7a5a12',
    fontSize: '0.9rem',
  },
  backBtn: {
    backgroundColor: '#1769d6',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '6px 14px',
    boxShadow: '0 4px 10px rgba(23,105,214,0.2)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
}));

export default function ParentSchoolBanner({ history }) {
  const classes = useStyles();
  const [session, setSession] = useState(null);
  const [viewingChild, setViewingChild] = useState(false);

  useEffect(() => {
    const refresh = () => {
      setSession(getParentSchoolSession());
      setViewingChild(isViewingChildSchool());
    };
    refresh();
    window.addEventListener('storage', refresh);
    return () => window.removeEventListener('storage', refresh);
  }, []);

  if (!viewingChild || !session) return null;

  const handleBack = async () => {
    try {
      const parentUser = await SchooleRegistrationService.restoreParentSession();
      if (!restoreParentSchoolSession(parentUser)) return;
      history.push('/app/addbranchschool');
      window.location.reload();
    } catch (e) {
      alert(e?.response?.data?.message || e?.message || 'Unable to return to parent school');
    }
  };

  const parentLabel = session.parentSchoolName || 'Parent School';

  return (
    <Box className={classes.banner}>
      <Box className={classes.info}>
        <BusinessIcon style={{ fontSize: 20, color: '#e65100' }} />
        <Typography variant="body2">
          You are viewing branch school:{' '}
          <strong>{session.childSchoolName || 'Branch'}</strong>
        </Typography>
      </Box>
      <Button
        variant="contained"
        className={classes.backBtn}
        startIcon={<ArrowBackIcon />}
        onClick={handleBack}
      >
        Back to {parentLabel}
      </Button>
    </Box>
  );
}
